import React from 'react';
import { Node } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';

export const Badge: React.FC<{ color: string; children: React.ReactNode }> = ({ color, children }) => {
    const classes = classnames('badge', color);
    return <Node className={classes}>{children}</Node>;
};
